import styled from "@emotion/styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { darken } from "@mui/system"
import { LoadingButton } from "@mui/lab"

export const CustomButton = styled(LoadingButton)`
  color: white;
  background-color: ${({ theme, color }) =>
    theme.palette[color]
      ? theme.palette[color].main
      : theme.palette.primary.main};
  padding: 0.875rem 1.25rem;
  border: 1px solid transparent;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-weight: 600;
  border-radius: 10px;
  text-transform: none;
  font-size: ${({ theme }) => theme.typography.pxToRem("17")};
  line-height: ${({ theme }) => theme.typography.pxToRem("26")};
  letter-spacing: 0.085px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0.875rem 1.5rem;
  }
  &.light {
    background-color: white;
    color: ${({ theme }) => theme.palette.secondary.dark};
    border: 1px solid ${({ theme }) => theme.palette.secondary.dark};
    &:hover {
      background-color: ${({ theme }) => theme.palette.tertiary.light};
    }
  }

  &.transparent {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.text.light};
    border: 1px solid ${({ theme }) => theme.palette.text.light};
    &:hover {
      background-color: ${({ theme }) => theme.palette.tertiary.light};
      color: ${({ theme }) => theme.palette.secondary.dark};
    }
  }

  &.bordered {
    color: ${({ theme }) => theme.palette.primary.main};
    border: 1px ${({ theme }) => theme.palette.primary.main} solid;
    background-color: transparent;

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.main};
      color: white;
    }
  }

  &.lightBorder {
    color: ${({ theme }) => theme.palette.secondary.light};
    border: 1px ${({ theme }) => theme.palette.secondary.light} solid;
    background-color: transparent;

    &:hover {
      background-color: ${({ theme }) => theme.palette.secondary.light};
      color: ${({ theme }) => theme.palette.secondary.dark};
    }
  }

  &:not(.light):not(.darkBorder):not(.lightBorder):not(.transparent):hover {
    background-color: ${({ theme, color }) =>
      darken(
        theme.palette[color]
          ? theme.palette[color].main
          : theme.palette.primary.main,
        0.1,
      )};
  }

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
    background: lightgray;
    border-color: lightgray;
    cursor: not-allowed;
  }
  &.MuiLoadingButton-loading {
    ::after {
      content: "";
      position: absolute;
      border-radius: 10px;
      inset: 0;
      background-color: lightgray;
      z-index: 1;
    }
    .MuiLoadingButton-loadingIndicator {
      z-index: 2;
    }
  }
`

export const CustomButtonLink = styled(AniLink)`
  color: white;
  background-color: ${({ theme, color }) =>
    theme.palette[color]
      ? theme.palette[color].main
      : theme.palette.primary.main};
  padding: 0.5em 1.5em;
  text-transform: unset;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-weight: 600;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  min-height: 40px;

  &.light {
    background-color: white;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.darkBorder {
    color: ${({ theme }) => theme.palette.primary.main};
    border: 1px ${({ theme }) => theme.palette.primary.main} solid;
    background-color: transparent;

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.main};
      color: white;
    }
  }

  &.lightBorder {
    color: white;
    border: 1px white solid;
    background-color: transparent;
  }

  &:not(.light):not(.darkBorder):hover {
    background-color: ${({ theme, color }) =>
      darken(
        theme.palette[color]
          ? theme.palette[color].main
          : theme.palette.primary.main,
        0.1,
      )};
  }

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
    background: lightgray;
    border-color: lightgray;
    cursor: not-allowed;
  }
`
